<template>
    <div class="column q-gutter-y-sm" style="margin-right: 15px">
        <q-input class="input" :readonly="this.isSent" :label="params.label" ref="input" v-model="value" type="text" borderless input-style="color: #85371F" :debounce="400" :autogrow="autogrow" :maxlength="autogrow ? maxLength : -1" @keydown.ctrl.enter.prevent="send" >
            <template v-slot:prepend>
                <q-img v-show="params.icon_url" :src="params.icon_url" style="color: #EAB191; height: 38px; width: 38px;" />
            </template>
        </q-input>
        <DefaultButton v-show="inited && !this.isSent" label="Отправить" @click="send" :loading="loading" />
    </div>
</template>

<script>
import uiControlMixin from 'src/mixins/ui/uiControlMixin';
import DefaultButton from 'components/ui/common/DefaultButton';

export default {
    name: 'Input',
    components: { DefaultButton },
    mixins: [uiControlMixin],
    props: {
        tag: {
            type: String,
            default: undefined,
        },
        icon: {
            type: String,
            default: undefined,
        },
    },
    mounted () {
        this.init();
    },
    data () {
        return {
            loading: false,
            inited: false,
            value: undefined,
            autogrow: true,
            maxLength: -1,
            isSent: false,
        };
    },
    methods: {
        init () {
            this.loading = true;
            this.isSent = false;
            this.value = undefined;
            const { user } = this.$store.state.pages;
            this.loading = true;
            this.$db.users.getUserInput(user.id, this.page.id, this.params.tag).then((value) => {
                if (value) {
                    this.value = value;
                    this.isSent = true;
                }
                this.loading = false;
                this.inited = true;
            });
        },
        select () {
            this.$refs.input.select();
        },
        send () {
            const { user } = this.$store.state.pages;
            this.loading = true;
            const pageTitle = this.page.title;
            const { label } = this.params;
            this.$db.users.sendUserInput(user.id, this.page.id, this.params.tag, this.value || '', pageTitle, label).then(() => {
                this.isSent = true;
                this.loading = false;
                this.$q.notify('Отправлено');
            });
        },
    },
};
</script>

<style scoped>
    .input {
        background-color: white;
        border-radius: 25px;
        padding: 0 10px 0 10px;
    }

</style>
